module.exports = __webpack_public_path__ + "img/payWayImg1.80fc4559.png";